import axios from "axios";
import { baseUrl } from "../utils/config";

const newBaseUrl = () => {
  if (window.location.protocol === "http:") {
    let newBaseUrl: string | undefined = baseUrl;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseUrl;
  }
};

export const fetchApiGet = async (
  token: string | null,
  endPoint: string,
  sessionID: string | null
) => {
  let response = await fetch(`${newBaseUrl()}${endPoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : "",
      "Auth-Session-Id": sessionID ? sessionID : "",
    },
  });
  let jsonResponse = await response.json();
  return jsonResponse;
};

export const fetchApiPost = async (
  token: string | null,
  endPoint: string,
  data: any,
  sessionID: string | null
) => {
  let response = await fetch(`${newBaseUrl()}${endPoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : "",
      "Auth-Session-Id": sessionID ? sessionID : "",
    },
    body: JSON.stringify(data),
  });
  let jsonResponse = await response.json();
  return jsonResponse;
};


export const getRequest = async (endPoint: string) => {
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Connection: "close",
      Authorization: "Bearer " + global.authToken,
    },
  });

  return response;
};
export const postRequest = async (endPoint: string, data: {}) => {
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      Connection: "close",
      Authorization: "Bearer " + global.authToken,
    },
    data: data,
    // timeout: requestTimeout,
  });

  return response;
};
export const postRequestAuth = async (endPoint: string, data: {}) => {
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      "api-key": "8X86M57V7K",
      Connection: "close",
    },
    data: data,
    // timeout: requestTimeout,
  });

  return response;
};